<template>
  <!-- 我的空间-机构备案展示组件（区分一级机构、二级机构，jgzl：1、2） -->
  <el-form :model="preexchangeForm" :rules="ruleExchangeForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <!-- 账号信息 -->
    <el-card class="box-cards system-logo">
      <div slot="header" class="card-title">
        <div></div>
        <span>账户密码</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="账号：" label-width="225px"> <el-input v-model="$store.state.user.tyshxydm"
              style="width: 250px" clearable type="input" disabled></el-input> </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="新密码：" label-width="225px">
            <el-input v-model.trim="preexchangeForm.password" style="width: 250px" clearable :readonly="operation"
              type="password"></el-input>
            <el-button size="small" type="primary" @click="updatePassWord()" style="margin-left: 10px">修改新密码</el-button>
          </el-form-item></el-col>
      </el-row>
    </el-card>
    <!-- 基本信息 -->
    <el-card class="box-cards system-logo">
      <div slot="header" class="card-title">
        <div></div>
        <span>基本信息</span>
      </div>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="服务机构名称：" prop="jgmc" label-width="225px"> <el-input v-model.trim="preexchangeForm.jgmc"
              style="width: 560px" clearable :disabled="operation"></el-input> </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item label="统一社会信用代码：" prop="tyshxydm" label-width="225px">
            <el-input v-model.trim="preexchangeForm.tyshxydm" style="width: 250px" clearable disabled></el-input>
          </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20" v-if="jgzl != '1'">
        <el-col>
          <el-form-item label="法人单位名称：" prop="frdw" label-width="225px"> <el-input v-model.trim="preexchangeForm.frdw"
              style="width: 250px" clearable disabled></el-input> </el-form-item></el-col>
      </el-row>
      <el-row class="logo-img" v-if="jgzl != '1'">
        <el-col :span="10">
          <el-form-item label="机构图片" prop="jgtpPath" label-width="500px">
            <el-upload class="avatar-uploader" :action="upload_Jgtp.action" :data="{ jgid: unitJgid }"  :headers="upload_Jgtp.token"  :show-file-list="false" 
              :before-upload="beforeAvatarUpload" :disabled="operation"  :on-success="handleAvatarSuccess">
              <img v-if="preexchangeForm.jgtpPath" :src="preexchangeForm.jgtpPath" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload> </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="联系人：" prop="jglxr" label-width="225px"> <el-input v-model.trim="preexchangeForm.jglxr"
              style="width: 250px" clearable :readonly="operation"></el-input> </el-form-item></el-col>
        <el-col :span="12">
          <el-form-item label="联系电话(手机号码)：" prop="jglxrdh" label-width="225px">
            <el-input v-model.trim="preexchangeForm.jglxrdh" style="width: 250px" clearable
              :readonly="operation"></el-input>
          </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="办公电话：" prop="bgdh" label-width="225px">
            <el-input v-model.trim="preexchangeForm.bgdh" style="width: 250px" clearable
              :readonly="operation"></el-input>
            <span style="color: red;margin-left: 5px;">例如：027-88888888</span>
          </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20" v-if="jgzl != '1'">
        <el-col :span="10" v-if="jgzl != '2'">
          <el-form-item label="邮箱：" prop="yx" label-width="225px"> <el-input v-model.trim="preexchangeForm.yx"
              style="width: 250px" clearable :readonly="operation"></el-input> </el-form-item></el-col>
        <el-col :span="24">
          <el-form-item label="机构地址：" prop="jgdz" label-width="225px">
            <el-cascader ref="fAddress" v-model="preexchangeForm.jgdz" :options="divisionHbDictList"
              :props="cityDictProps" style="width: 300px" @change="handleChange" :disabled="operation">
            </el-cascader>
            <el-input v-model="preexchangeForm.txdz" style="width: 500px; margin-left: 10px"
              :disabled="operation"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="jgzl != '1'">
        <el-col>
          <el-form-item label="服务领域（多选）：" prop="sscyly" label-width="225px" class="fwlyStyle">
            <el-checkbox-group v-model="preexchangeForm.sscyly" class="columngroup2" :disabled="operation">
              <el-checkbox v-for="(option, index) in sscylyList" :key="index" :label="option.dictCode">{{
                option.dictValue }}</el-checkbox>
              <!-- 点击其他按钮才会展示输入框信息 -->
              <template v-if="preexchangeForm.sscyly.includes('99')">
                <el-input v-model.trim="preexchangeForm.sscylyDetail" style="width: 200px;margin-left: 10px;"
                  size="mini" :disabled="operation"></el-input>
              </template>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="jgzl != '1'">
        <el-col>
          <el-form-item label="服务机构类型（可多选）：" prop="fwjglx" label-width="225px" class="fwlyStyle">
            <el-checkbox-group v-model="preexchangeForm.fwjglx" :disabled="operation" @change="changeCheckBox">
              <el-checkbox v-for="(option, index) in fwjglxList" :key="index" :label="option.dictCode" :disabled="option.disabled">{{
                option.dictValue }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20" v-if="jgzl == '2' && preexchangeForm.fwjglx.includes('04')">
        <el-col>
          <el-form-item label="是否为ICP和ISP：" prop="isIcpisp" label-width="225px">
            <el-radio v-model="preexchangeForm.isIcpisp" label="0">否</el-radio>
            <el-radio v-model="preexchangeForm.isIcpisp" label="1">是</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="preexchangeForm.isIcpisp == 1">
          <el-form-item label="资质证书有效期（研发服务）:" prop="yfEZsyxrq" label-width="225px">
            <el-date-picker v-model="preexchangeForm.yfEZsyxrq" type="date" placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss" style="width: 250px" value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="operation">
            </el-date-picker>
          </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20" v-if="jgzl == '2' && preexchangeForm.fwjglx.includes('02')">
        <el-col :span="12">
          <el-form-item label="资质证书有效期（检验检测）:" prop="jyjcZsyxrq" label-width="225px">
            <el-date-picker v-model="preexchangeForm.jyjcZsyxrq" type="date" placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss" style="width: 250px" value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="operation">
            </el-date-picker>
          </el-form-item></el-col>
      </el-row>
      <el-row :gutter="20" v-if="jgzl == '2' && preexchangeForm.fwjglx.includes('02')">
        <el-col :span="24">
          <el-form-item label="检验类别:" label-width="225px" class="jylb">
            <el-input v-model.trim="input.value" v-for="(input, index) in jylbInputs" :key="index"
              style="width: 250px;margin-left: 5px;" :disabled="operation"></el-input>
            <span style="margin-left: 10px;color: rgb(92, 182, 255);font-size: 18px;cursor: pointer;" @click="addInput"
              v-if="!operation">
              <i class="el-icon-circle-plus"></i>
            </span>
            <span style="margin-left: 10px;color: rgb(245, 108, 108);font-size: 18px;cursor: pointer;"
              @click="removeInput" v-if="!operation">
              <i class="el-icon-remove" style="margin-left: 5px;"></i>
            </span>
          </el-form-item></el-col>
      </el-row>
      <el-row style="display: flex; justify-content: center;flex-direction: column;align-items: center" v-if="!operation && jgzl != '2'">
        <el-col :span="24" style="display: flex; justify-content: center">
          <el-checkbox v-model="checked" class="submit_checkbox"></el-checkbox>
          <span style="color: red; margin-left: 10px; font-weight: bold; font-size: 16px">*</span>
          <span style="font-weight: bold; font-size: 16px;color:#000"
            @click="checked = !checked">我单位声明：此次提交的申报材料均真实、合法；如有不实之处，愿负相应的法律责任，并承担由此产生的一切后果。特此声明！</span>
        </el-col>
        <br />
        <el-button size="small" type="primary" @click="submitExchangeForm()"
          style="width: 100px" :disabled="!checked">提交</el-button>
      </el-row>
    </el-card>
    <!-- 附件上传 -->
    <el-card class="box-cards upload-attachments" v-if="jgzl == '2'">
      <div slot="header" class="card-title">
        <div></div>
        <span>附件上传</span>
        <span
          style="color: red; font-weight: 800; margin-left: 10px;font-size: 15px;">注：以下材料均需要清晰，并按以下各项附件栏目提示要求加盖公章。（上传附件请提供pdf格式文件,可上传多个文件）</span>
      </div>
      <template v-for="item in wjlxList">
        <el-row :gutter="50" v-if="item.show" :key="item.dictCode">
          <el-col :span="6"><span class="upload-title">{{ item.dictValue }}</span></el-col>
          <el-col :span="10" style="display: flex; flex-direction: column; align-items: flex-start">
            <el-upload ref="uploadFile" class="upload-demo" :action="upload.action" :headers="upload.token"
              :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1"
              :show-file-list="false" :before-upload="beforeAvatarUpload2" :on-success="(response, file, fileList) => {
                return handUploadFileSuccess(response, file, fileList, item.dictCode)
              }
                " :on-error="handUploadFileError" :data="{ jgid: unitJgid, wjlx: item.dictCode }" accept=".pdf"
              :disabled="operation">
              <div>
                <span style="color: red; margin-right: 5px; font-size: 16px; font-weight: bold"
                  v-if="item.routeUrl === '1'">*</span>
                <!-- <span style="color: rgb(103, 194, 58); margin-right: 5px; font-size: 16px; font-weight: bold" v-if="item.routeUrl === '0'">*</span> -->
                <span class="upload-icon"><i class="el-icon-upload2"></i>上传</span>
              </div>
            </el-upload>
            <div class="up-list_item">
              <div class="up-list_item_row" v-for="(item2, index2) in item.fileList" :key="index2">
                <div class="fileName">
                  <el-link type="success" icon="el-icon-document" :underline="false">{{ item2.wjm }} （{{ item2.wbdx |
                    bytesToKB }}）</el-link>
                </div>
                <div class="fileTools">
                  <el-button size="small" type="text" class="text-danger" @click="removeFile(item2.fjid)"
                    :disabled="operation">删除
                  </el-button>
                  <el-button size="small" type="text" @click="previewFile(item2.fjid)">预览 </el-button>
                  <el-button size="small" type="text" @click="downloadFile(item2.fjid)">下载</el-button>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div>
              <template v-if="item.dictCode === '025'">
                <div v-for="(item2, index) in item.auxiliaryValue.split(';')" :key="index">
                  <span class="upload-waring">{{ item.remark.split(';')[index] }}</span>
                  <!-- 请查看 -->
                  <!-- <span
                    style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                    @click="handleDownTemplate(item2, '检验检测')" v-if="item.auxiliaryValue">请查看</span> -->
                  <br />
                </div>
                <span class="upload-waring">CMA样例: <span style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"  @click="handleDownTemplate(item.auxiliaryValue.split(';')[0], '检验检测')">请查看</span></span> 
                <span class="upload-waring" style="margin-left:15px">CNAS样例:<span style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"  @click="handleDownTemplate(item.auxiliaryValue.split(';')[1], '检验检测')">请查看</span></span>                
              </template>
              <template v-else-if="item.dictCode === '006'">
                <div v-for="(item2, index) in item.auxiliaryValue.split(';')" :key="index">
                  <span class="upload-waring">{{ item.remark.split(';')[index] }}</span>
                  <!-- <br /> -->
                </div>
                <span class="upload-waring">样例1: <span
                    style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                    @click="handleDownTemplate(item.auxiliaryValue.split(';')[0], '检验检测')">请查看</span></span>
                <span class="upload-waring" style="margin-left:15px">样例2:<span
                    style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                    @click="handleDownTemplate(item.auxiliaryValue.split(';')[1], '检验检测')">请查看</span></span>
              </template>
              <template v-else>
                <span class="upload-waring" v-html="item.remark"></span>
                <span
                  style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px;margin-left: 5px;"
                  @click="handleDownTemplate(item)" v-if="item.auxiliaryValue">请查看</span>
              </template>
            </div>
          </el-col>
        </el-row>
      </template>
    </el-card>
    <!-- 提交操作栏 -->
    <el-row style="display: flex; flex-direction: column; justify-content: space-around" v-if="jgzl == '2'">
      <el-col :span="24" style="display: flex; justify-content: center">
        <el-checkbox v-model="checked" class="submit_checkbox"></el-checkbox>
        <span style="color: red; margin-left: 10px; font-weight: bold; font-size: 16px">*</span>
        <span style="font-weight: bold; font-size: 16px;color:#000"
          @click="checked = !checked">我单位声明：此次提交的申报材料均真实、合法；如有不实之处，愿负相应的法律责任，并承担由此产生的一切后果。特此声明！</span>
      </el-col>
      <br />
      <el-col :span="24" style="display: flex; justify-content: center" v-if="!operation">
        <el-button size="small" type="primary" @click="submitExchangeForm()" style="width: 100px"
          v-if="preexchangeForm.jgshzt === '110'" :disabled="!checked">提交</el-button>
        <el-button size="small" type="primary" @click="submitExchangeForm('secondUpdate')" style="width: 100px"
          v-if="preexchangeForm.jgshzt === '009'" :disabled="!checked">修改</el-button>
      </el-col>
    </el-row>
    <newDialog :visible="showDialog" title="温馨提示" @confirm="showDialog = false" @closeDialog="showDialog = false" :showCancelBtn="false" :showConfirmBtn="false">
        <template v-slot:tb>
          <img src="../../../assets/images/notice.png" alt="" />
        </template>
        <!-- 弹窗内容 -->
        <span style="font-weight: bold; font-size: 20px;color:red">服务资质即将过期，请及时更新。</span>
    </newDialog>
  </el-form>
</template>
<script>
import { printPdfView, downloadFileRecord, removeFileRecord, updateUserPassWord } from '@/api/mechanism/enterApply'
import { getDictionaryList, recursionDictData } from '@/api/enterprise/exchangelist'
import { getJgFileList, getfwJgLxType, applyOrAudit, enterApply } from '@/api/mechanism/enterApply'
import { previewFileTemplateManage } from '@/api/index.js'
import { getDqJgDetail, updateDqJgDetail } from '@/api/mechanism/indexCenter.js'
import { getToken } from '@/utils/cache'
import { validateUniscid, validateEmail, validateMobile, validateOfficTelephone } from '@/utils/jr-validate.js'
import { mapGetters } from 'vuex'
import { validateStrongPassword } from '@/utils/jr-validate'
import { getUuid } from '@/utils'
import { getIsFullData } from '@/api/mechanism/indexCenter.js'
import newDialog from '@/components/newDialog'

export default {
  components: { newDialog },
  props: {
    // 是否禁用
    operation: {
      type: Boolean,
      default: false
    },
    // 是否显示退回消息
    sendBack: {
      type: Boolean,
      default: false
    },
    // 是否显示流程图
    shlcStatus: {
      type: Boolean,
      default: false
    },
    // 是否有关闭按钮
    see: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    bytesToKB: function (bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      let size = bytes / k
      let unit = 'KB'
      if (size > k) {
        size /= k
        unit = 'MB'
      }
      return size.toFixed(2) + ' ' + unit
    }
  },
  computed: {
    ...mapGetters(['jgzl'])
  },
  data() {
    return {
      upload_Jgtp: {
        action: process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/uploadJgtp',
        token: {
          Internettoken: getToken()
        }
      },
      // 入驻申请表单对应的form信息
      preexchangeForm: {
        jgmc: this.$store.state.user.enterName,
        tyshxydm: this.$store.state.user.tyshxydm,
        qyfr: this.$store.state.user.legalName,
        qyfrlxfs: this.$store.state.user.phone,
        jgtpPath: '',
        bgdh: '',
        txdz: '',
        mhwz: '',
        lxdh: '',
        zcsj: '',
        yfEZsyxrq: '',
        isIcpisp: '0',
        jyjcZsyxrq: '',
        jgjj: '',
        jgszqy: '',
        qyfrsfzh: '',
        jglxr: '',
        jglxrdh: '',
        gskhh: '',
        gszhmc: '',
        gszhzh: '',
        khhhh: '',
        khzhlxdh: '',
        khzhdz: '',
        zhmc: '',
        jgshzt: '',
        sjly: '',
        sqrzrq: '',
        zczbwy: '',
        yx: '',
        zzrysl: '',
        jyfw: '',
        fwjglx: [],
        cjr: '',
        frdw: '',
        gdbs: '',
        jgfl: '',
        rzpc: '',
        jgszs: '',
        jgdz: [],
        // 新密码
        password: '',
        // 企业所属领域
        sscyly: [],
        // 企业所属领域详情
        sscylyDetail: ''
      },
      // 企业所属领域（单选）
      sscylyList: [],
      // 入驻申请表单所需的 form 验证规则
      ruleExchangeForm: {
        // 机构名称：
        jgmc: [{ required: true, message: '请选择机构名称', trigger: 'change' }],
        jglxr: [{ required: true, message: '请输入机构联系人', trigger: 'change' }],
        jglxrdh: [
          { required: true, message: '请输入机构联系人电话', trigger: 'change' },
          { validator: validateMobile, trigger: 'change' }
        ],
        bgdh: [
          { required: true, message: '请输入办公电话', trigger: 'change' },
          { validator: validateOfficTelephone, trigger: 'change' }
        ],
        yx: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          { validator: validateEmail, trigger: 'change' }
        ],
        jgdz: [{ required: true, message: '请选择机构所在地址', trigger: 'change' }],
        tyshxydm: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'change' },
          { validator: validateUniscid, trigger: 'change' }
        ],
        qyfrlxfs: [
          { required: true, message: '请输入单位法人联系方式', trigger: 'change' },
          { validator: validateMobile, trigger: 'change' }
        ],
        qyfr: [{ required: true, message: '请输入单位法人', trigger: 'change' }],
        frdw: [{ required: true, message: '请输入法人单位名称', trigger: 'change' }],
        jgtpPath: [{ required: true, message: '请上传机构图片', trigger: 'change' }],
        zczbwy: [{ required: true, message: '请输入注册资本（万元）', trigger: 'change' },
        { pattern: /^\d+(\.\d+)?$/, message: '只能输入数字类型的值', trigger: 'blur' }
        ],
        zcsj: [{ required: true, message: '请选择成立日期', trigger: 'change' }],
        yfEZsyxrq: [{ required: true, message: '请选择资质证书有效期', trigger: 'change' }],
        jyjcZsyxrq: [{ required: true, message: '请选择资质证书有效期', trigger: 'change' }],
        jylb: [{ required: true, message: '请输入检验类别', trigger: 'change' }],
        zzrysl: [{ required: true, message: '请输入专职人员数量', trigger: 'change' },
        { pattern:  /^(0|[1-9]\d*)$/, message: '只能输入0或者大于0的整数', trigger: 'blur' }
        ],
        jgfl: [{ required: true, message: '请选择机构分类', trigger: 'change' }],
        fwjglx: [{ required: true, message: '请选择服务机构类型', trigger: 'change' }],
        jyfw: [{ required: true, message: '请输入经营范围', trigger: 'change' }],
        password: [
          { required: true, message: '请输入新密码', trigger: 'change' },
          { validator: validateStrongPassword, trigger: 'blur' }
        ],
        // 企业所属领域
        sscyly: [{ required: true, message: '请选择服务领域', trigger: 'change' }],
        // 企业所属领域详情
        sscylyDetail: [{ required: true, message: '请输入服务领域详情', trigger: 'blur' }],
        isIcpisp: [{ required: true, message: '请选择是否为ICP和ISP', trigger: 'change' }],
      },
      fwjglxList: [], //服务机构类型数组
      jgflList: [], //机构分类数组
      wjlxList: [], //文件类型数组
      deepWjlxList: [], //深拷贝文件类型数组
      deepWjlxList2: [], //深拷贝文件类型数组
      // 湖北省行政区划字典
      divisionHbDictList: [],
      cityDictProps: {
        label: 'dictValue',
        value: 'dictCode',
        children: 'childSysDictionaryList'
      },
      upload: {
        action: process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/uploadJgrzsqFile',
        token: {
          Internettoken: getToken()
        }
      },
      // 当前的机构id
      unitJgid: '',
      uuid: '',
      // 检验类别的输入框数据列表
      jylbInputs: [{ value: '' }],
      showDialog:false,
      // 提交表单时的复选框验证
      checked: false,
    }
  },
  async created() {
    // 查询企业地址信息
    this.handleGetHbDivision()
    // 获取当前的机构信息
    this.getDqJgDetail()
  },
  mounted() { },
  methods: {
    // 检验类别输入框的添加按钮
    addInput() {
      this.jylbInputs.push({ value: '' }); // 点击按钮添加一个输入框
    },
    // 检验类别输入框的删除按钮
    removeInput() {
      if (this.jylbInputs.length > 1) {
        this.jylbInputs.pop(); // 点击按钮删除最后一个输入框
      }
    },
    // 获取机构信息方法
    async getDqJgDetail() {
      // 在获取字典信息一遍
      await this.getDictionaryList()
      const res = await getDqJgDetail()
      if (res.code === 200) {
        const { data } = res

        if (data.expireRemind == 1) {
          this.showDialog = true
        }

        this.preexchangeForm = data
        // 回显机构分类
        this.preexchangeForm.jgfl = this.jgflList.filter((item) => {
          return item.dictCode == data.jgfl
        })[0]
        // 回显服务机构类型
        if (data.fwjglx === null) {
          this.preexchangeForm.fwjglx = []
        } else {
          this.preexchangeForm.fwjglx = data.fwjglx.split(';')
          // 回显服务机构类型所选的文件附件
          this.changeCheckBox(this.preexchangeForm.fwjglx)
        }
        // 回显服务领域
        if (data.sscyly === null) {
          this.preexchangeForm.sscyly = []
        } else {
          this.preexchangeForm.sscyly = data.sscyly.split(';')
        }
        // 回显机构地址
        // 企业地址级联选择器
        if (data.jgszqy === null) {
          this.$set(this.preexchangeForm, 'jgdz', [])
        } else {
          this.$set(this.preexchangeForm, 'jgdz', ['420000', data.jgszs, data.jgszqy])
        }

        // 回显上传文件的信息
        this.getExchangeListAttach(data.jgid)

        // 保存当前的jgid
        this.unitJgid = data.jgid
        // 回显图片
        // if (data.jgtpPath) {
        //   this.preexchangeForm.jgtpPath = `data:image/png;base64,${data.jgtpPath}`
        // }
        // 回显检验类别
        if (data.jylb) {
          this.jylbInputs.length = 0
          let valuesToAdd = data.jylb.split(';');
          // 将拆分后的值逐个添加到 arr1 中
          valuesToAdd.forEach(value => {
            this.jylbInputs.push({ value });
          });
        }
        // 服务机构类型添加disabled
        console.log(data,'data');
        if(data.yffw1FileLockState){

        }
        this.fwjglxList.forEach(item => {
          if(item.dictCode === '03' && data.yffw1FileLockState ){
            item.disabled = true
          }
          if(item.dictCode === '04' && data.yffw2FileLockState ){
            item.disabled = true
          }
          if(item.dictCode === '02' && data.jyjcFileLockState ){
            item.disabled = true
          }
          if(item.dictCode === '01' && data.dxyqFileLockState ){
            item.disabled = true
          }
        })
      }
    },
    async getDictionaryList() {
      // 服务机构类型
      let a = await getfwJgLxType()
      // 机构分类
      let b = await getDictionaryList({
        parentCode: 'DIM_JGFL'
      })
      // 附件上传文件类型
      let c = await getDictionaryList({
        parentCode: 'DIM_WJLX'
      })
      // 企业所属领域（单选）
      let d = await getDictionaryList({
        parentCode: 'DIM_SSZYLY'
      })
      // 处理请求结果
      if (a.code === 200) {
        this.fwjglxList = a.data
      }
      if (b.code === 200) {
        this.jgflList = b.data
      }
      if (c.code === 200) {
        this.wjlxList = c.data.filter((item) => {
          this.$set(item, 'fileList', [])
          this.$set(item, 'show', false)
          return item.dictCode === '006' || item.dictCode === '026' || item.dictCode === '027' || item.dictCode === '025'
        })
      }
      if (d.code === 200) {
        this.sscylyList = d.data
      }
    },
    // 查询湖北省行政区划
    handleGetHbDivision() {
      let params = {
        parentId: '420000',
        level: '3'
      }
      recursionDictData(params).then((response) => {
        const { data } = response

        this.divisionHbDictList.push(data)
      })
    },
    // 选择级联地址
    handleChange() {
      const pathLabels = this.$refs.fAddress.getCheckedNodes()[0].pathLabels
      this.preexchangeForm.txdz = pathLabels.join('').replaceAll('省直辖县级行政区划', '')
    },
    // 提交表单信息
    submitExchangeForm(secondUpdate) {
      // 点击新增的时候，当前表单会生成一个最新且唯一的uuid标识
      this.uuid = getUuid()
      // 需要做表单校验
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.moveToErr()
        } else {
          // 判断当前是否存在收据文件，如果有，则必须要加以判断，如果没有则判断附件上传
          if (this.jgzl == '2') {
            // 判断附件文件上传的完整性，通过字典中的路由地址来判断，如果需要更改则在后台管理中进行配置
            const result = this.wjlxList.some((e) => {
              return e.routeUrl === '1' && e.fileList.length == 0
            })
            // 说明存在有必填标识，但是文件数据为空
            if (result) {
              this.$message.warning('请先上传所需的附件，再进行提交表单')
              return
            }
          }
          // 二级机构更新信息
          if (secondUpdate === 'secondUpdate') {
            this.submitApplyPost('secondUpdate')
          } else {
            this.submitApplyPost()
          }
        }
      })
    },
    updatePassWord() {
      // 判断是否有手机号
      // if(!this.preexchangeForm.jglxrdh){
      //   this.$message.error('修改密码请先完善基本信息，联系人电话请填写手机号，后续将用于密码找回和系统消息通知等。')
      //   return false
      // }
      // 判断当前用户信息是完善
      getIsFullData()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            if (!data) {
              this.$message.warning('修改密码请先完善基本信息，联系人电话请填写手机号，后续将用于密码找回和系统消息通知等')
            } else {
              //判断账户密码修改，不能为空
              if (this.preexchangeForm.password === '') {
                this.$message.error('新密码不能为空')
                return false
              }
              const validMap = /^.*(?=.{6,18})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*?\(\)]).*$/
              let isPass = validMap.test(this.preexchangeForm.password.trim())
              if (!isPass) {
                this.$message.error('密码为6-18字符，至少包含一个大小写字母、数字和特殊符号！')
                return false
              }
              let data = {
                userName: this.$store.state.user.tyshxydm,
                newPassword: this.preexchangeForm.password
              }
              updateUserPassWord(data)
                .then((res) => {
                  if (res.code == 200) {
                    // 修改密码成功
                    this.$message.success('修改密码成功')
                  } else {
                    // 修改密码失败
                    this.$message.error('修改密码失败')
                  }
                })
                .catch((err) => {
                  this.$message.error(err)
                })
            }
          } else {
            this.$message.error('系统异常，请稍后再试')
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    },
    moveToErr() {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName('is-error')
        if (isError.length) {
          isError[0].scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          })
        }
      })
    },
    async submitApplyPost(secondUpdate) {
      const list = { ...this.preexchangeForm }
      list.jgid = this.unitJgid
      // 需要处理机构分类、机构地址、企业支持类型
      // 机构分类
      list.jgfl = list.jgfl ? list.jgfl.dictCode : ''
      if (list.fwjglx.length) {
        list.fwjglx = list.fwjglx.join(';')
      } else {
        list.fwjglx = ''
      }
      // 服务领域多选
      if (list.sscyly.length) {
        list.sscyly = list.sscyly.join(';')
      } else {
        list.sscyly = ''
      }
      if (list.jgdz.length > 0) {
        list.jgszs = list.jgdz[1]
        list.jgszqy = list.jgdz[2]
      } else {
        list.jgszs = ''
        list.jgszqy = ''
      }
      // 处理图片数据
      // if (list.jgtpPath) {
      //   list.jgtpPath = list.jgtpPath.split(',')[1]
      // } else {
      //   list.jgtpPath = ''
      // }
      // 这边要做发起请求区分
      if (this.jgzl == '1') {
        const result = await updateDqJgDetail(list)
        if (result.code == 200) {
          this.$message.success('操作成功')
          this.getDqJgDetail()
          setTimeout(() => {
            location.reload()
          }, 500)
        } else {
          this.$message.error(result.message)
        }
      } else {
        // 处理当前服务机构类型是否选中了检验检测，那么就要传值证书有效期和检验类别给后端
        if (list.fwjglx.includes('02')) {
          let result = this.jylbInputs.map(obj => obj.value).join(';');
          list.jylb = result
        }
        // 走审核流程
        // 封装成一个对象newList，传递给后端
        let newList = {
          // 操作环节
          linkCode: '005',
          // 兑付状态
          status: '009',
          formData: list
        }

        // 判断是添加、更新
        if (secondUpdate === 'secondUpdate') {
          const result = await updateDqJgDetail(list)
          if (result.code == 200) {
            this.$message.success('修改成功')
            this.getDqJgDetail()
          } else {
            this.$message.error(result.message)
          }
        } else {
          const result = await enterApply(newList)
          if (result.code == 200) {
            this.$message.success('操作成功')
            this.getDqJgDetail()
            this.$store
              .dispatch('user/getSecondJgInfo').then(
                setTimeout(() => {
                  location.reload()
                }, 500)
              )
          } else {
            this.$message.error(result.message)
          }
        }
      }
    },
    handleAvatarSuccess(res) {
      this.preexchangeForm.jgtpPath = res.data
    },
    beforeAvatarUpload(file) {
      // console.log(file.type)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 4
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG /png格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 4MB!')
      }
      return isJPG && isLt2M
    },
    // 限制不超过4M
    beforeAvatarUpload2(file) {
      const isPDF = file.type === 'application/pdf'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isPDF) {
        this.$message.error('上传附件只能是 PDF 格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传pdf文件不能超过 10MB!')
      }
      return isPDF && isLt10M
      // return isPDF
    },
    beforeRemove(file, fileList) {
      if (file && file.status == 'success') {
        return this.$confirm(`确定移除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      // 删除图片
      console.log('handleRemove', file, fileList)
    },
    // 查看文件
    handlePreview(file) {
      console.log(file)
    },
    // 上传文件成功
    handUploadFileSuccess(response, file, fileList, dictCode) {
      if (response && response.code === 200) {
        this.$message.success('上传成功')
        // 回传事件，进行附件记录的更新
        this.getExchangeListAttach(this.unitJgid)
        let uploadFile = this.$refs.uploadFile.filter((item) => {
          return item.data.wjlx == dictCode
        })[0]
        uploadFile.clearFiles()
        // this.$refs.uploadFile[index].clearFiles()
      } else {
        this.$message.error(response.message)
      }
    },
    // 上传失败
    handUploadFileError() {
      this.$message.error('上传失败')
    },
    //删除文件
    removeFile(fileId) {
      this.$modal
        .confirm('是否删除该附件')
        .then(function () {
          return removeFileRecord({ fileId: fileId })
        })
        .then((res) => {
          // 成功之后
          if (res.code === 200) {
            if (res.data == '操作成功') {
              this.$message.success('删除成功')
              this.getExchangeListAttach(this.unitJgid)
            } else {
              this.$message.error('删除失败')
            }
          }
        })
    },
    // 预览文件
    previewFile(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      //预览文件
      window.open(printPdfView(paramsStr))
    },
    // 下载文件
    downloadFile(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      window.open(downloadFileRecord(paramsStr), '_blank')
    },
    // 查看兑付详情所有的附件
    async getExchangeListAttach(val) {
      const result = await getJgFileList({
        jgid: val
      })
      const { data } = result
      if (data.length == 0) {
        this.wjlxList.forEach((element) => {
          this.$set(element, 'fileList', [])
        })
        return
      } else {
        this.wjlxList = this.mergeFilesByCode(this.wjlxList, data, 'dictCode', 'wjlx')
      }
    },
    // 定义一个函数来将 dataList 添加到 wjlxList 的 fileList 中
    mergeFilesByCode(wjlxList, dataList, dictCodeKey, wjlxKey) {
      // 将 dataList 按照 wjlx 分组
      const groupedData = dataList.reduce((acc, obj) => {
        const key = obj[wjlxKey]
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})

      // 遍历 wjlxList，将对应的 fileList 填充
      wjlxList.forEach((item) => {
        const wjlx = item[dictCodeKey]
        if (groupedData[wjlx]) {
          this.$set(
            item,
            'fileList',
            groupedData[wjlx].map((obj) => {
              return obj
            })
          )
        } else {
          this.$set(item, 'fileList', [])
        }
      })

      return wjlxList
    },
    // 请查看
    handleDownTemplate(item, stringValue) {
      if (stringValue === '检验检测') {
        window.open(previewFileTemplateManage(item))
      } else {
        window.open(previewFileTemplateManage(item.auxiliaryValue))
      }
    },
    // 选择服务机构分类复选框
    changeCheckBox(value) {
      // value 01为大型科学006;  02检验检测025;  03研发服务一026;  04研发服务二027
      let arr = []
      value.forEach((element) => {
        if (element === '01') {
          arr.push('006')
        } else if (element === '02') {
          arr.push('025')
        } else if (element === '03') {
          arr.push('026')
        } else if (element === '04') {
          arr.push('027')
        }
      })
      // 使用 map 方法遍历 arr1 数组，并根据匹配情况修改 routeUrl 字段
      this.wjlxList = this.wjlxList.map((item) => {
        if (arr.includes(item.dictCode)) {
          return { ...item, routeUrl: '1', show: true }
        } else {
          return { ...item, routeUrl: '0', show: false }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  .grid {
    width: 1400px;
    // min-height: 942px;
    background: #ffffff;
    padding-bottom: 20px;
    margin-bottom: 40px;
  }

  .grid-box {
    width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    box-sizing: border-box;
  }

  .breadcrumb {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
  }

  .active {
    color: #00000066;
  }

  .cont-box {
    margin-top: 12px;
    width: 1200px;
    min-height: 500px;
    border: 1px solid #dfdfdf;
    padding: 15px 20px;
    text-align: center;

    .cont-header {
      text-align: right;
    }

    .content-text {
      padding: 26px 50px;
      text-align: left;
    }

    .table-container {
      padding: 10px 0;
    }
  }
}

// 企业兑付申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    .el-checkbox-group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
    flex: 1 !important;
  }
}

::v-deep .columngroup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup2 {
  display: flex;
  flex-direction: row !important;
  flex-wrap: wrap;

  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup3 {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .el-radio {
    margin-bottom: 10px;
  }
}

.warnig_text {
  color: red;
  font-weight: bold;
  margin-left: 15px;
  font-size: 16px;
}

::v-deep.upload-attachments {
  .el-card__body {
    .el-row {
      min-height: 100px;
      border-bottom: 1px solid rgb(205, 211, 220);
      display: flex;
      align-items: center;

      .upload-title {
        font-size: 15px;
        font-weight: 800;
        color: #606266;
      }

      .upload-icon {
        cursor: pointer;
        font-size: 16px;
        color: rgb(86, 165, 253);

        i {
          margin-right: 5px;
        }
      }

      .upload-waring {
        color: red;
        font-size: 16px;
      }
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.system-logo {
  position: relative;

  .logo-img {
    position: absolute;
    top: 10%;
    left: 58%;

    .el-form-item {
      align-items: center;
    }
  }
}

.avatar-uploader {
  line-height: 10px;
  border: 1px dashed #d9d9d9 !important;
}

.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.up-list_item {
  background: rgba(144, 161, 183, 0.06);

  .up-list_item_row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background: #f4f5f5;
    }

    .fileName .el-link {
      font-size: 15px;
    }
  }
}

::v-deep .shlc {
  .el-step__title {
    font-size: 14px !important;
  }

  .el-step__head.is-process {
    color: rgb(90, 156, 248);
    border-color: rgb(90, 156, 248);
  }

  .el-step__title.is-process {
    color: rgb(90, 156, 248);
  }
}

::v-deep .fwlyStyle {
  .el-form-item__content {
    flex: 1 !important;
  }
}

::v-deep .jylb .el-form-item__content{
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}

::v-deep .submit_checkbox{
  .el-checkbox__inner{
    border-color: #606266;
  }
}
</style>
